'use es6';

import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { debounce } from 'underscore';
import { getMenuNode } from 'simple-menus-core/selectors/menuNode';
import MenuNode from 'simple-menus-core/models/MenuNode';
import * as MenuNodeActions from 'simple-menus-core/actions/MenuNode';
import { DEFAULT_DEBOUNCE_TIME } from 'simple-menus-core/constants/constants';
import { jsx as _jsx } from "react/jsx-runtime";
function makeMapStateToProps() {
  return function mapStateToProps(state, props) {
    return {
      menuNode: getMenuNode(state, props)
    };
  };
}
const mapDispatchToProps = {
  updateNode: MenuNodeActions.updateNode
};
const HOC = Component => {
  class WithConnectedMenuLabel extends PureComponent {
    constructor(props) {
      super(props);
      this.updateLabel = debounce(this.updateLabel.bind(this), DEFAULT_DEBOUNCE_TIME);
      this.onLabelChange = this.onLabelChange.bind(this);
    }
    updateLabel(linkLabel) {
      this.props.updateNode(this.props.id, {
        linkLabel
      });
    }
    onLabelChange({
      target: {
        value
      }
    }) {
      this.updateLabel(value);
    }
    render() {
      const {
        id,
        menuNode,
        hasChildren,
        toggleCollapse,
        isCollapsed,
        readOnly
      } = this.props;
      return /*#__PURE__*/_jsx(Component, {
        id: id,
        label: menuNode.linkLabel,
        onLabelChange: this.onLabelChange,
        hasChildren: hasChildren,
        toggleCollapse: toggleCollapse,
        isCollapsed: isCollapsed,
        readOnly: readOnly
      });
    }
  }
  WithConnectedMenuLabel.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    menuNode: PropTypes.instanceOf(MenuNode).isRequired,
    hasChildren: PropTypes.bool.isRequired,
    toggleCollapse: PropTypes.func.isRequired,
    isCollapsed: PropTypes.bool.isRequired,
    updateNode: PropTypes.func.isRequired,
    readOnly: PropTypes.bool
  };
  WithConnectedMenuLabel.defaultProps = {
    menuNode: new MenuNode({})
  };
  return connect(makeMapStateToProps, mapDispatchToProps)(WithConnectedMenuLabel);
};
export default function withConnectedMenuLabel() {
  return HOC;
}